import React from "react";
import { createRoot } from "react-dom/client";
import { RtfmDemoApp } from "./components/RtfmDemoApp.js";
import { ThemeProvider } from "./hooks/useTheme.js";

const rootElement = document.getElementById("app");
if (!rootElement) {
  throw new Error("Missing #app container in index.html");
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <RtfmDemoApp />
    </ThemeProvider>
  </React.StrictMode>,
);

